import mixins from 'vue-typed-mixins';
import { FileExportMixin } from '@codequality/vue-cli-base';

import { 事業所Api, 事業所ListItemResponse } from '@/openapi/user';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import AlertMixin from '@/mixins/AlertMixin';
import 企業ユーザーMixin from '@/entries/user/mixins/企業ユーザーMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(FileExportMixin, RoutesMixin, AlertMixin, 企業ユーザーMixin, 事業所Mixin).extend({
  name: 'P事業所List',

  data(): {
    api: 事業所Api;
    事業所s: 事業所ListItemResponse[];
  } {
    return {
      api: UserApiUtility.ogApi(事業所Api),
      事業所s: [],
    };
  },

  created(): void {
    // 担当者ログインの時は、c事業所pkを取得して事業所選択処理へ
    if (this.is担当者) {
      this.select事業所(this.me.c事業所pk!);
      return;
    }
    this.$_load();
  },

  methods: {
    async $_load(): Promise<void> {
      const response = await this.api.list事業所();
      this.事業所s = response.data;
    },

    async backup(pk: number): Promise<void> {
      if (!confirm('バックアップしますか？')) return;

      const printResponse = await this.api.backup事業所(pk, this.getExportOptions());
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.exportFile(printResponse, process.env.VUE_APP_IS_MOCK === 'true');
    },

    async remove(pk: number): Promise<void> {
      const isCancelOrError = await this.isCancelOrValidationErrorResponseToDelete(() =>
        this.api.logicalDelete事業所(pk)
      );
      if (isCancelOrError) return;
      this.$_load();
    },

    async select事業所(pk: number): Promise<void> {
      await this.set事業所(pk);
      // 担当者ログインの時は計画書画面へ、それ以外は勘定科目画面へ遷移
      this.$router.push({
        name: this.is担当者 ? this.routes.計画書.name : this.routes.勘定科目.name,
      });
    },
  },
});
